module.exports = __webpack_public_path__ + "img/ser.8c5feb88.png";